<section class="hero is-large">
  <div class="hero-body"></div>
  <div *ngIf="isLoggedIn$ === false && isNewsPage === true">
    <a href="https://intro.esrtheta.nl/">
      <button class="button">Word lid!</button>
    </a>
    <div id="video-background-container">
      <video id="video-background" autoplay muted loop playsinline webkit-playsinline preload="auto">
        <source src="/assets/Theta_hero_video.mp4" type="video/mp4" />
      </video>
    </div>
  </div>
</section>